import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { MixPanelService } from '@app/core/analytics/mixpanel.service';
import { MIXPANEL_EVENTS, pageNameFromUrl } from '@app/core/analytics/mixpanel-events';

export const editorGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const mixPanelService = inject(MixPanelService);

  // On hard refresh the auth state can still be empty.
  // Recover session first, then evaluate editor role.
  if (!authService.currentUser()) {
    if (authService.isMockAuthEnabled()) {
      authService.ensureMockSession();
    } else if (authService.getToken()) {
      await authService.validateToken();
    }
  }

  if (authService.isEditor()) {
    return true;
  }

  // DD Access - denied: attemptedPage comes from the guarded route path ('master-tables' / 'logs').
  const attemptedPage = pageNameFromUrl(`/${route?.routeConfig?.path ?? ''}`);
  mixPanelService.track(MIXPANEL_EVENTS.ACCESS_DENIED, {
    ...(attemptedPage === 'master tables' || attemptedPage === 'logs' ? { attemptedPage } : {}),
    reason: 'editor only',
  });

  router.navigate(['/']);
  return false;
};
